


























































































































import Component from 'vue-class-component';
import { Vue, Watch } from 'vue-property-decorator';

import { SNACK_EVENT_NAME, SnackEvent, SnackType } from '@/events';
import { Menu } from '@/model/Menu';
import { Product } from '@/model/Product';
import { Service } from '@/model/Service';
import Site from '@/model/Site';
import { menusService } from '@/services/menus.service';
import { Getters } from '@/store/getters';
import { Mutations } from '@/store/mutations';
import { ArrayLengthRule, NotEmptyRule, ValidationRule } from '@/validation/validation.rules';
import DateSelectorField from './DateSelectorField.vue';
import ProductSearchField from './ProductSearchField.vue';
import { DATE_CONFIG } from './menus.constants';

@Component({
  components: {
    DateSelectorField,
    ProductSearchField,
  },
})
export default class ProductFormDialogMove extends Vue {
  menu = false;

  valid = false;

  selectedService: Service | undefined = undefined;

  products: Product[] = [];

  selectedDate: Date | null = null;

  selectedProducts: Product[] = [];

  get site(): Site | null {
    return this.$store.getters[`${Getters.SITE}`];
  }

  get services(): Service[] {
    return this.$store.getters[`${Getters.SERVICES}`];
  }

  get service(): Service | null {
    return this.$store.getters[`${Getters.SERVICE}`];
  }

  get date(): Date | null {
    return this.$store.state.date;
  }

  get currentMenu(): Menu | null {
    return this.$store.getters[`${Getters.CURRENT_MENU}`];
  }

  @Watch('formDialog')
  opening(newValue: boolean, oldValue: boolean): void {
    if (newValue && !oldValue) {
      // Ouverture
      this.products = this.currentMenu ? this.currentMenu.products : [];
      this.selectedDate = this.$store.getters[`${Getters.DATE}`];
      this.selectedService = this.$store.getters[`${Getters.SERVICE}`];
    }
  }

  async submit() {
    if (!this.site || !this.selectedDate || !this.selectedService || !this.currentMenu) {
      this.snack('Les conditions de soumissions ne sont pas valides', SnackType.ERROR, 5000);
      return;
    }
    const { site, selectedDate, selectedService, currentMenu } = this;

    Promise.resolve().then(() => {
      return menusService
        .moveProducts(
          currentMenu._id || '',
          selectedDate.toISOString(),
          selectedService.code,
          site.customerId,
          this.selectedProducts.map(product => product._id || ''),
        )
        .then(() => {
          return 'Produit/s modifié/s avec succès';
        })
        .catch(error => {
          this.snack(
            `Erreur lors de la mise à jour du menu (code ${error.response?.status})`,
            SnackType.ERROR,
            5000,
          );
          throw error;
        })
        .finally(() => {
          this.close();
        })
        .then(async okMessage => {
          this.$store.commit(
            `${Mutations.SET_MENUS}`,
            await menusService.getMenus(site.customerId),
            { root: true },
          );
          this.$store.commit(`${Mutations.SELECT_DATE}`, this.selectedDate, { root: true });
          this.$store.commit(`${Mutations.SELECT_SERVICE}`, this.selectedService, {
            root: true,
          });
          const newCurrentMenu = (this.$store.getters[`${Getters.MENUS}`] as Menu[]).find(
            (menu: Menu) =>
              menu.date === this.date?.toISOString() && menu.serviceCode === this.service?.code,
          );
          if (newCurrentMenu && newCurrentMenu._id) {
            const updatedCurrentMenu = await menusService
              .getCurrentMenu(newCurrentMenu._id)
              .catch(e => {
                this.snack(
                  `Erreur lors de la mise à jour du menu. (${e.response?.status}) Actualisez la page.`,
                  SnackType.ERROR,
                  5000,
                );
              });
            this.$store.commit(`${Mutations.SET_CURRENT_MENU}`, updatedCurrentMenu, {
              root: true,
            });
          }
          if (okMessage) this.snack(okMessage);
        })
        .finally(() => {
          this.$store.commit(`${Mutations.RELEASE_LOADING}`, { root: true });
        });
    });
  }

  close() {
    this.selectedProducts = [];
    if (this.$refs.form) {
      const form = this.$refs.form as HTMLFormElement;
      form.resetValidation();
    }
    this.formDialog = false;
  }

  selectService(newService: Service | undefined) {
    this.selectedService = newService;
  }

  dateInput(dateStr: string) {
    this.menu = false;
    this.selectedDate = new Date(dateStr);
  }

  set formDialog(v: boolean) {
    this.$store.commit(`${Mutations.FORM_DIALOG_MOVE}`, v, { root: true });
  }

  get formDialog(): boolean {
    return this.$store.getters[`${Getters.FORM_DIALOG_MOVE}`];
  }

  get formattedValue(): string {
    if (this.value) return this.value.toLocaleString('fr-FR', DATE_CONFIG);
    return '';
  }

  get valueForDatepicker(): string {
    if (this.value) return this.value.toISOString().substring(0, 10);
    return '';
  }

  get value(): Date | null {
    return this.selectedDate;
  }

  get serviceRules(): ValidationRule[] {
    return [NotEmptyRule];
  }

  get productsRule(): ValidationRule[] {
    return [ArrayLengthRule];
  }

  set isAllProducts(event: boolean) {
    this.selectedProducts = event ? this.products : [];
  }

  get isAllProducts() {
    return this.selectedProducts.length === this.products.length;
  }

  snack(message: string, type = SnackType.SUCCESS, timeout = 3500, multiline = false) {
    this.$root.$emit(SNACK_EVENT_NAME, new SnackEvent(message, type, timeout, multiline));
  }

  get maxWidth(): string {
    if (this.$vuetify.breakpoint.xl) return '55%';
    if (this.$vuetify.breakpoint.lgAndUp) return '65%';
    return '100%';
  }
}
